<template>
  <div class="home">
    <van-nav-bar
      left-arrow
      :title="'ID:' + staff.account"
      fixed
      @click-left="$router.push('/StaffList')"
    >
      <van-icon
        name="./static/img/Trash.png"
        slot="right"
        @click="delStaff()"
        style="font-size: 24px;"
      />
    </van-nav-bar>
    <van-cell-group>
      <van-field
        class="inputAr"
        :label="$t('NewStaff.name')"
        v-model="staff.name"
      />
      <van-field
        class="inputAr"
        :label="$t('NewStaff.gender')"
        readonly
        clickable
        right-icon="arrow"
        :value="genderText"
        @click="showGenderPicker = true"
      />
      <van-popup v-model="showGenderPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="genders"
          @cancel="showGenderPicker = false"
          @confirm="onGenderConfirm"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
        />
      </van-popup>
      <van-field
        class="inputAr"
        :label="$t('NewStaff.birth')"
        readonly
        clickable
        right-icon="arrow"
        :value="staff.birthday | formatDate1"
        @click="showBirthdayPicker = true"
      />
      <van-popup v-model="showBirthdayPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showBirthdayPicker = false"
          @confirm="
            staff.birthday = currentDate;
            showBirthdayPicker = false;
          "
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
        />
      </van-popup>
      <van-popup v-model="showAreaCodePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showAreaCodePicker = false"
          @confirm="onConfirm"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
        />
      </van-popup>
      <van-field
        class="inputAr"
        :label="$t('NewStaff.phone')"
        v-model="staff.phone"
      />
      <van-field
        class="inputAr"
        :label="$t('NewStaff.workTime')"
        readonly
        clickable
        right-icon="arrow"
        :value="staff.entry_time | formatDate1"
        @click="showEntryTimePicker = true"
      />
      <van-popup v-model="showEntryTimePicker" position="bottom">
        <van-datetime-picker
          v-model="currentEntryDate"
          type="date"
          :min-date="minDate"
          @cancel="showEntryTimePicker = false"
          @confirm="
            staff.entry_time = currentEntryDate;
            showEntryTimePicker = false;
          "
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
        />
      </van-popup>
      <van-image
        class="noInput"
        width="100%"
        height="150"
        fit="contain"
        :src="staff.qrcode + '?time=' + clickTime"
      />
      <van-field
        class="noInput"
        readonly
        :label="$t('EditStaff.link')"
        :value="staff.link"
        type="textarea"
        autosize
      />
      <div class="refreshWrapper">
        <span class="refreshText">{{ $t("EditStaff.copy") }}:</span>
        <!-- {{$t('EditStaff.copy')}} -->
        <div class="refresh" @click="copy()">{{ $t("EditStaff.copyBtn") }}</div>
      </div>
      <div class="refreshWrapper">
        <span class="refreshText">{{ $t("EditStaff.refresh") }}:</span>
        <div class="refresh" @click="refreshQRcode()">
          {{ $t("EditStaff.refreshBtn") }}
        </div>
      </div>
    </van-cell-group>
    <div class="bottom">
      <van-button
        class="issueBtn"
        round
        type="default"
        style="font-weight:bold;font-size:16px;"
        @click="patchStaff()"
        >{{ $t("EditStaff.submit") }}</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      staff: {
        name: "",
        phone: "",
        gender: 1,
        birthday: "",
        entry_time: "",
        area_code: "",
        post: "",
        password: "",
        store_id: sessionStorage.actShopId,
        link: "",
        qrcode: ""
      },
      clickTime: 0,
      genders: [
        {
          value: 0,
          text: this.$t("NewStaff.woman")
        },
        {
          value: 1,
          text: this.$t("NewStaff.man")
        }
      ],
      posts: [
        {
          text: this.$t("NewStaff.staff"),
          post: "waiter"
        }
        // {
        // 	text:'厨师',
        // 	post:'chef',
        // },
        // {
        // 	text:'店长',
        // 	post:'manager',
        // },
      ],
      postText: "",
      genderText: this.$t("NewStaff.man"),
      areaName: "",
      columns: [],
      showGenderPicker: false,
      showSetTimePicker: false,
      showStartTimePicker: false,
      showAreaCodePicker: false,
      showBirthdayPicker: false,
      showEntryTimePicker: false,
      showPostPicker: false,
      currentDate: new Date(),
      currentEntryDate: new Date(),
      staffs: {
        link: "",
        qrcode: ""
      },
      minDate: new Date(1950, 0, 1),
      maxDate: new Date()
    };
  },
  mounted: function() {
    this.getAreacode();
    this.getStaff();
  },
  methods: {
    onConfirm(value, index) {
      this.staff.area_code = this.columns[index].acnumber;
      this.areaName = value.text;
      this.showAreaCodePicker = false;
    },
    onPostConfirm(value, index) {
      this.staff.post = this.posts[index].post;
      this.postText = this.posts[index].text;
      this.showPostPicker = false;
    },
    onGenderConfirm(value, index) {
      this.staff.gender = this.genders[index].value;
      this.genderText = this.genders[index].text;
      this.showGenderPicker = false;
    },
    getAreacode() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/areacode"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.columns = res.data.data;
            for (var i = 0; i < this.columns.length; i++) {
              this.columns[i].text =
                this.columns[i].acnumber +
                "(" +
                this.columns[i].acname_cn +
                ")";
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewStaff.message")
          });
        });
    },
    getStaff() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/user/" + this.$route.params.id + "/detail"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.staff = res.data.data;
            for (var i = 0; i < this.columns.length; i++) {
              if (this.columns[i].acnumber == res.data.data.area_code) {
                this.areaName = this.columns[i].text;
              }
            }
            for (var i = 0; i < this.posts.length; i++) {
              if (this.posts[i].post == res.data.data.post) {
                this.postText = this.posts[i].text;
              }
            }
            this.genderText = this.genders[res.data.data.gender].text;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewStaff.message")
          });
        });
    },
    patchStaff() {
      // if(this.staff.name&&this.staff.phone&&this.staff.post&&this.staff.birthday&&this.staff.entry_time&&this.staff.password){
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/user/" + this.$route.params.id + "/edit",
        data: this.staff
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            console.log(this.staffs);
            const vm = this;
            setTimeout(function() {
              vm.$router.push("/StaffList");
            }, 1500);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewStaff.message")
          });
        });
      // }else{
      // 	this.$toast(this.$t('NewStaff.toast'));
      // }
    },
    delStaff() {
      this.$dialog
        .confirm({
          title: this.$t("EditStaff.delStaff"),
          message: this.$t("EditStaff.isDelStaff"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          this.$axios({
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url: this.$build + "/api/user/" + this.$route.params.id + "/delete"
          })
            .then(res => {
              console.log(res);
              if (res.data.status == 200) {
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
                const vm = this;
                setTimeout(function() {
                  vm.$router.push("/StaffList");
                }, 1500);
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("NewStaff.message")
              });
            });
        })
        .catch(() => {});
    },
    refreshQRcode() {
      //刷新二维码及链接
      this.$dialog
        .confirm({
          title: this.$t("SetSeat.refresh"),
          message: this.$t("SetSeat.refreshTip"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          this.$axios({
            method: "get",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url: this.$build + "/api/user/" + this.$route.params.id + "/refresh"
          })
            .then(res => {
              console.log(res);
              if (res.data.status == 200) {
                this.clickTime = this.clickTime + 1;
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
                this.getStaff();
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("NewStaff.message")
              });
            });
        })
        .catch(() => {});
    },
    copy() {
      //复制当剪切板
      let transfer = document.createElement("input");
      document.body.appendChild(transfer);
      transfer.value = this.staff.link; // 这里表示想要复制的内容
      transfer.focus();
      transfer.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      transfer.blur();
      document.body.removeChild(transfer);
      this.$toast({
        duration: 800,
        type: "success",
        message: this.$t("EditStaff.success")
      });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell .van-icon {
  font-size: 20px;
}
.home {
  width: 100%;
  /*height: 100vh;*/
  background: #f3f5f7;
  padding-bottom: 60px;
}
.inputAr .van-field__body input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-cell-group {
  background: #f3f5f7;
  /* padding-top: 46px; */
}
.selSex {
  width: 50px;
  float: right;
}
@media screen and (min-width: 800px) {
  .bottom {
    width: 800px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 800px) {
  .bottom {
    width: 100%;
    margin: 0 auto;
  }
}
.bottom {
  position: fixed;
  bottom: 0;
  height: 60px;
  background: #f3f5f7;
}
.issueBtn {
  width: 90%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #000;
  color: #fff;
}
.link {
  word-wrap: break-word;
  padding: 20px;
}
.qrcodeImg {
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.noInput {
  background-color: #f3f5f7;
  margin-top: 10px;
}
.refresh {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
  background: #2f75f4;
  margin: 10px auto;
  margin-right: 10px;
}
.refreshWrapper {
  display: flex;
}
.refreshText {
  line-height: 50px;
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/Staff/EditStaff.vue